<script setup lang="ts">
import FieldInput from '~/components/Form/FieldInput.vue'

const count = defineModel({ type: Number, required: true })
const isEditMode = ref(false)

function checkNumber() {
  if (count.value < 1) {
    count.value = 1
  } else if (count.value > 1000) {
    count.value = 1000
  }
  isEditMode.value = false
}

function switchToEditMode() {
  isEditMode.value = true
  nextTick(() => {
    countInputEl.value?.focus()
  })
}

const countInputEl = ref<HTMLInputElement | null>(null)
</script>

<template>
  <div class="flex flex-nowrap">
    <button
      v-if="!isEditMode"
      class="flex h-10 w-10 items-center justify-center border-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
      :disabled="count <= 1"
      @click="
        () => {
          if (count > 1) {
            count--
          }
        }
      "
    >
      <Icon name="fa6-solid:minus" class="h-4 2xl:h-6" />
    </button>
    <div
      class="flex h-10 items-center border-y-2 border-neutral-200 px-5 2xl:h-12 2xl:px-8 2xl:text-lg"
      :class="{ 'border-l-2': isEditMode }"
    >
      <span class="font-pragmatica-ext whitespace-nowrap font-bold">
        <template v-if="!isEditMode">
          <div @click="switchToEditMode">
            {{ count + ' ' + $t('configurator.pieces') }}
          </div>
        </template>
        <template v-else>
          <input
            ref="countInputEl"
            v-model="count"
            @focusout="checkNumber"
            type="number"
            class="no-spinner w-full max-w-[100px] !rounded-none text-right !outline-none"
          />
          {{ $t('configurator.pieces') }}
        </template>
      </span>
    </div>
    <button
      v-if="!isEditMode"
      :disabled="count >= 1000"
      @click="
        () => {
          if (count < 1000) {
            count++
          }
        }
      "
      class="flex h-10 w-10 items-center justify-center border-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
    >
      <Icon name="fa6-solid:plus" class="h-4 2xl:h-6" />
    </button>
    <button
      v-if="isEditMode"
      @click="isEditMode = false"
      class="flex h-10 w-10 items-center justify-center border-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
    >
      <Icon name="fa6-solid:check" class="h-4 2xl:h-6" />
    </button>
    <button
      v-if="!isEditMode"
      @click="switchToEditMode"
      class="flex h-10 w-10 items-center justify-center border-y-2 border-r-2 border-neutral-200 hover:bg-neutral-100 2xl:h-12 2xl:w-12"
    >
      <Icon name="fa6-solid:pen" class="h-4 2xl:h-6" />
    </button>
  </div>
</template>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
